import React from 'react';
import BaseScadaNode from './BaseScadaNode';

export function ValveSVG({ value, config = {}, width = 40, height = 40, type = 'gate' }) {
    const isOpen = parseFloat(value) >= (parseFloat(config.threshold ?? 0.5));
    const color = isOpen ? (config.open_color || '#22C55E') : (config.closed_color || '#EF4444');
    const cx = width / 2;
    const cy = height / 2;
    const r = Math.min(width, height) / 2 - 4;

    if (type === 'ball' || type === 'valve_ball') {
        return (
            <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }}>
                <circle cx={cx} cy={cy} r={r} fill={color} stroke="#94A3B8" strokeWidth={1.5} />
                <line x1={cx - r * 0.6} y1={cy} x2={cx + r * 0.6} y2={cy} stroke="#0F172A" strokeWidth={isOpen ? 2 : 0} />
                <line x1={cx} y1={cy - r * 0.6} x2={cx} y2={cy + r * 0.6} stroke="#0F172A" strokeWidth={isOpen ? 0 : 2} />
                {/* Stem */}
                <rect x={cx - 3} y={2} width={6} height={8} rx={2} fill="#94A3B8" />
            </svg>
        );
    }

    // Default: gate valve — two triangles ISA style
    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }}>
            {/* Left triangle */}
            <polygon
                points={`${cx},${cy} ${4},${4} ${4},${height - 4}`}
                fill={color} stroke="#94A3B8" strokeWidth={1.5}
            />
            {/* Right triangle */}
            <polygon
                points={`${cx},${cy} ${width - 4},${4} ${width - 4},${height - 4}`}
                fill={color} stroke="#94A3B8" strokeWidth={1.5}
            />
            {/* Stem */}
            <rect x={cx - 3} y={2} width={6} height={cy - 4} rx={2} fill="#94A3B8" />
        </svg>
    );
}

export default function ValveNode(props) {
    const { data } = props;
    const w = data?.width || 40;
    const h = data?.height || 40;
    return (
        <BaseScadaNode {...props}>
            <ValveSVG value={data?.liveValue} config={data?.config} width={w} height={h} type={data?.element_type} />
            {data?.label && (
                <div style={{ textAlign: 'center', fontSize: 10, color: '#94A3B8', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {data.label}
                </div>
            )}
        </BaseScadaNode>
    );
}
